import React from 'react';
import classNames from 'classnames/bind';
import { PostDesignType } from '../../types/post';
import styles from './Quotation.module.scss';

const cx = classNames.bind(styles);

export type QuotationProps = {
  children: React.ReactNode;
  designType: PostDesignType;
};

function Quotation({ children, designType }: QuotationProps): JSX.Element {
  return (
    // [D] 들어가는 문양에 따라 '-case1' ~ '-case4' 까지 클래스 추가해주세요
    <div className={cx('quotation_wrap', `-case${designType}`)}>
      <div className={cx('quotation_text')}>{children}</div>
    </div>
  );
}

export default Quotation;
